export default `
/* ============================
   CONTENEDOR
============================ */

.shipping-label-wrapper {
  display: flex;
  justify-content: center;
  overflow: hidden;
  padding: 5mm;
}

.shipping-label {
  overflow: hidden;

  width: 100mm;
  height: 150mm;

  background: #fff;
  border: .6mm solid #000;
  box-sizing: border-box;

  display: flex;
  flex-direction: column;

  font-family: Arial, Helvetica, sans-serif;
  color: #000;
}

/* ============================
   HEADER
============================ */

.header {
  height: 25mm;

  display: flex;
  align-items: center;

  padding: 4mm;
  box-sizing: border-box;
}

.store {
  display: flex;
  align-items: center;
  width: 100%;
}

.store-logo {
  height: 14mm;
  object-fit: contain;
  margin-right: 4mm;
}

.store-info {
  display: flex;
  flex-direction: column;
}

.store-name {
  font-size: 14pt;
  font-weight: bold;
}

.store-field {
  font-size: 8pt;
  color: #666;
}

/* ============================
   DIVIDER
============================ */

.divider {
  height: .5mm;
  background: #000;
  flex-shrink: 0;
  margin-left: 4mm;
  margin-right: 4mm;
}

/* ============================
   QR
============================ */

.qr-section {
  height: 50mm;

  display: flex;
  justify-content: center;
  align-items: center;
}

.qr-content {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.qr-image {
  width: 32mm;
  height: 32mm;
  object-fit: contain;
}

.tracking-code {
  font-size: 20pt;
  font-weight: bold;
}

/* ============================
   DESTINATARIO
============================ */

.recipient {
  height: 45mm;

  padding: 4mm;
  box-sizing: border-box;
  overflow: hidden;
}

.recipient-label {
  display: block;

  font-size: 7pt;
  color: #666;

  text-transform: uppercase;
  letter-spacing: .5pt;
  margin-top: 3mm;
  margin-bottom: 1mm;
}

.recipient-commune {
  display: block;

  font-size: 14pt;
  font-weight: bold;

  text-transform: uppercase;

  margin-bottom: 1mm;
}

.recipient-name {
  display: block;
  font-size: 10pt;


  font-weight: bold;

  text-transform: uppercase;
}

.recipient-text {
  display: block;

  font-size: 10pt;
  line-height: 1.35;
}

/* ============================
   FOOTER
============================ */

.footer {
  flex: 1;
  max-height: 25mm;
  display: flex;
  justify-content: space-between;
  align-items: center;

  padding: 4mm;
  box-sizing: border-box;
}

.footer-label {
  display: block;

  font-size: 7pt;
  color: #666;

  text-transform: uppercase;
}

.footer-title {
  display: block;

  font-size: 12pt;
  font-weight: bold;
}

.footer-user {
  display: block;

  font-size: 8pt;
  color: #666;
}

.courier-logo {
  height: 100%;
  object-fit: contain;
}

/* ============================
   IMPRESIÓN
============================ */

@page {
  size: 100mm 150mm;
  margin: 0;
}

@media print {

  html,
  body {
    margin: 0;
    padding: 0;
    background: #fff;
  }

  .shipping-label-wrapper {
    padding: 0;
    margin: 0;
    background: #fff;
  }

  .shipping-label {
    border: .6mm solid #000;
    page-break-after: always;
  }
}`
